import { useMutation } from '@tanstack/react-query';
import { useAppContext } from 'src/contexts/AppContext';
import { useClientLogContext } from 'src/contexts/ClientLogContext';
import { useUserHasFeature } from 'src/hooks/useUserHasFeature';
import { tryInvokeApi } from 'src/utils/tryExecuteUtils';
import {
  Feature,
  ReachProSupportCaseClient,
  ReachProSupportCaseLookupResponse,
} from 'src/WebApiController';

export type ReachProSupportCaseLookupInput = {
  listingId?: number;
  saleId?: number;
};

export function useReachProSupportCaseLookup() {
  const { activeAccountWebClientConfig } = useAppContext();
  const { trackError } = useClientLogContext();
  const hasReachProSupportFeature = useUserHasFeature(Feature.ReachProSupport);

  return useMutation({
    mutationFn: async ({
      listingId,
      saleId,
    }: ReachProSupportCaseLookupInput): Promise<ReachProSupportCaseLookupResponse | null> => {
      if (!hasReachProSupportFeature) {
        return null;
      }

      return tryInvokeApi(
        async () => {
          return await new ReachProSupportCaseClient(
            activeAccountWebClientConfig
          ).getExistingSupportCase(listingId, saleId);
        },
        (error) => {
          trackError('ReachProSupportCaseClient.getExistingSupportCase', error);
        }
      );
    },
  });
}
